<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
      <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
    </div>
  </div>
</div>
<div class="page_bottom_space" style="min-height:385px">
  @if (commonService.commonMainObj.validationCheck) {
    <div class="bg_image">
      <div class="upload_main_div">
        <div class="upload_div">
          <div class="xtra_div"></div>
          @if (uploadshow) {
            <div>
              <div class="mt-4">
                <span class="fs-4 text-white">Please provide file details </span>
                <!-- <span class="fs-4 fw-bolder text-white">Let's get </span>  -->
                <!-- <span class="fs-4 fw-bolder start_text">started!</span> -->
              </div>
              <!-- <div class="mt-3">
              <p class="m-0 text-white fs-6">Upload your PCB design files & </p>
              <p class="m-0 text-white fs-6">get an instant online quote for the industry's fastest turnaround time.</p>
            </div> -->
            <div class="row mt-2">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="pl-2">
                  <label class="text-white">Part Number <span class="text-danger">*</span></label>
                  <br />
                  <input class="form-control" type="text" value="{{uploadedFilesData.partNumber}}" [(ngModel)]="uploadedFilesData.partNumber" name="partNumber">
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="pe-4">
                  <label class="text-white">Revision <span class="text-danger">*</span></label>
                  <br />
                  <input class="form-control" type="text" value="{{uploadedFilesData.partRevision}}" [(ngModel)]="uploadedFilesData.partRevision" name="partRevision">
                </div>
              </div>
            </div>
            <div class="mt-2 mb-3">
              <input type="file" name="customFileUpload" class="form-control" id="customFileUpload" style="visibility:hidden ;" (change)="uploadFiles($event)" />
              <button class="btn btn-danger fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()">Cancel</button>
              <label for="customFileUpload" (click)="proceedCheck()">
                <!-- <i class="fa fa-cloud-upload text-white" aria-hidden="true"></i>  -->
                <div class="btn btn-warning fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true">
                  <b> Proceed</b>
                </div>
              </label>
            </div>
            <!-- <div class="mt-4 mb-4 pt-2" *ngIf="!uploadedFilesData.partNumber && !uploadedFilesData.partRevision!">
            <button class="btn btn-warning fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="proceedCheck()">Proceed</button>
            <button class="btn btn-danger fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()">Cancel</button>
          </div> -->
          <!-- <button class="btn btn-lg btn-outline-primary" (click)="open(mymodal)">Open My Modal</button> -->
          <!-- <ng-template #mymodal let-modal> -->
            <!-- <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Bootstrap Modal</h4>
            <button type="button" class="close fs-3 pb-0 pt-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div> -->
          <!-- <div class="modal-body">
            <app-login-pages></app-login-pages>
          </div> -->
          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button>
        </div> -->
      <!-- </ng-template> -->
    </div>
  }
  @if (!uploadshow) {
    <div class="mt-5 mb-5">
      <button type="button" class="btn btn-warning fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true">
        <i class="fa fa-refresh text-white rotate" aria-hidden="true"></i>  <b> &nbsp; Validating your file, please wait...</b>
      </button>
      <div class="pt-2 text-white fs14">
        {{commonService.commonMainObj.file.name}}
      </div>
      <div class="progress m-3">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-label="Example with label" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
  }
</div>
</div>
</div>
}
<div id="scrollTop" style="visibility: hidden;">

</div>
@if (!commonService.commonMainObj.validationCheck) {
  <div class="p-4">
    <input type="file" name="checkFileUpload" accept=".zip,.tar,.tgz" class="form-control" id="checkFileUpload" style="visibility:hidden ;" (change)="uploadFiles($event)" />
    <div class="fs-4 pt-2 text-center fw-b">Uploaded File Details</div>
    @if (commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.uploadedFilesData?.fileErrors.length>0 && !this.commonService.commonMainObj.moreFileFormatError) {
      <div class="mt-2 mb-2 fw-bolder">
        <p class="text-danger mb-2">Please fix all errors and re-upload files to get a quote</p>
      </div>
    }
    @if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length>0 && !commonService.commonMainObj.fileFormatError && !this.commonService.commonMainObj.moreFileFormatError) {
      <div class="">
        <div class="p-2 file-errors fw-b">Errors: <p style="font-style: italic;margin-bottom: 0;font-size: 14px;">Click over the info icon <span class="fa fa-info-circle"></span> next to each error for additional details</p> </div>
        <div class="brd_danger">
          <ul class="list-type-number">
            @for (errData of commonService.commonMainObj.uploadedFilesData?.fileErrors; track errData; let indx = $index) {
              <li>{{errData.error}}
                <div class="ofp-tooltip">
                  <span class="fa fa-info-circle" (mouseover)="showToolTip(errData.description,indx+1)" (mouseout)="hideToolTip(errData.description,indx+1)"></span>
                  <span class="tooltiptext" id="infoIcon-{{indx+1}}"></span>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    @if (commonService.commonMainObj.uploadedFilesData?.fileWarnings && !this.commonService.commonMainObj.moreFileFormatError) {
      <div class="mt-3">
        <!-- below p tag content is commented as Anjana suggested -->
        <!-- <p class="fsit mt-4" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.uploadedFilesData?.fileErrors.length==0 && !this.commonService.commonMainObj.moreFileFormatError">You may address the warnings right away along with the errors, or fix them later if needed after placing an order.<br /><b>NOTE: </b>If you decide to address the warnings after placing an order, the final quote may be subject to change.</p> -->
        <!-- commented based on OFP-1010 -->
        <!-- <div class="p-2 file-warning fw-b" style="border: 0.5px solid #ffc107;">Warnings: <p style="font-style: italic;margin-bottom: 0;font-size: 14px;">Click over the info icon <span class="fa fa-info-circle"></span> next to each warning for additional details</p></div> -->
        <!-- <div class="brd_warning">
        <ul class="list-type-number">
          <li *ngFor="let warData of commonService.commonMainObj.uploadedFilesData?.fileWarnings; let in = index">{{warData.warning}}
            <div class="ofp-tooltip">
              <span class="fa fa-info-circle" (mouseover)="showToolTip(warData.description,in+1)" (mouseout)="hideToolTip(warData.description,in+1)" ></span>
              <span class="tooltiptext" id="infoIcon-{{in+1}}"></span>
            </div>
          </li>
        </ul>
      </div> -->
      <!-- OFP-1010 comment ends -->
      @if (commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0) {
        <div class="text_warning mt-3" style="font-size: 0.9rem;font-style: italic;"><b>We found few discrepancies/missing files in the uploaded design package.</b><br/>You have the option to address the warnings by uploading new files right away, or you can continue with your current files to receive a quote and place an order.<br/>If you choose to proceed without fixing the warnings, you can rectify them later by uploading new files through the portal by accessing your order.<br/><br/><b>NOTE:</b> If you decide to address the warnings after placing an order, the final quote may be subject to change.</div>
      }
      <div class="table-row">
        <table class="table warning-table mt-4" style="width: 100%; word-break: break-word;">
          <thead>
            <tr>
              <th style="width: 50%;text-align:center; background-color:#fcb816;">Warning</th>
              <th style="width: 50%;text-align:center; background-color:#fcb816;">Additional Information</th>
            </tr>
          </thead>
          <tbody>
            @for (warData of commonService.commonMainObj.uploadedFilesData?.fileWarnings; track warData; let in = $index) {
              <tr>
                <td style="width: 50%;vertical-align: top;"><span style="font-size: 1rem;color:#e37403;font-weight: 500;">{{warData.warning}}</span></td>
                <td style="width: 50%; color: #59544f;">{{warData.description}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length>0 &&  !commonService.commonMainObj.uploadedFilesData?.fileWarnings && !commonService.commonMainObj.fileFormatError) {
    <div class="text-center text-danger mt-5 mb-3 fw-bolder">Please fix all errors and re-upload files to get a quote</div>
  }
  <!-- <div class="mt-5 mb-5 text-center fw-bolder"  *ngIf="commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.uploadedFilesData?.fileErrors.length==0"><span class="text-danger">Please fix all errors and re-upload files to get a quote</span><br /><span style="color:#fb8a04">You may address the warnings right away along with the errors, or fix them later if needed after placing an order.<br /><b>NOTE: </b>If you decide to address the warnings after placing an order, the final quote may be subject to change.</span></div> -->
  <!-- <div class="text-danger mb-3" *ngIf="commonService.commonMainObj.uploadedFilesData.fileWarnings && !commonService.commonMainObj.uploadedFilesData.fileErrors"><b>NOTE:</b> If you place order with the current files, you can upload the new files from the portal by accessing the order. But the final quote post assessing new files may change</div> -->
  @if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0) {
    <div class="mt-5 mb-3"><b>Design Package Preview:</b> </div>
  }
  @if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0) {
    <div>
      <form name="fileForm">
        <div style="display: flex;">
          <div class="pe-xl-4">
            <label for="designer-package-name">Design Package Name <span class="text-danger">*</span></label>
            <br />
            <input id="designer-package-name" #designFName class="form-control" type="text" [(ngModel)]="this.commonService.commonMainObj.designPackageName" (keyup)="fileNameChange($event)" name="fileName" title="{{commonService.commonMainObj.designPackageName}}"/>
          </div>
          <div class="pe-xl-4">
            <label for="part-number">Part Number <span class="text-danger">*</span></label>
            <br />
            <div  style="display: flex; align-items: baseline;">
              <input id="part-number" #partNum class="form-control" type="text" [(ngModel)]="commonService.commonMainObj.uploadedFilesData.partNumber" name="partNumber" maxlength="40" (keyup)="commonService.removeRedBorder('part-number'); changeInSelectInput($event)">

              @if(this.commonService.commonMainObj.partNumHide){
                <div  class="ofp-tooltip" id="partNumHide">
                  <img class=" " src="assets/img/{{commonService.commonMainObj.partNumberImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(commonService.commonMainObj.partNumberImg)" (mouseout)="hideImageToolTip(commonService.commonMainObj.partNumberImg)" style="margin-left: 10px;"/>
                  <span class="tooltiptext right-img-tooltip lableImageLabel-{{commonService.commonMainObj.partNumberImg}}"></span>
                </div>
              }
            </div>
            

            <div style="color:red; font-size:10px">Maximum 40 characters</div>
          </div>
          <div class="pe-xl-4">
            <label for="part-revision">Revision <span class="text-danger">*</span></label>
            <br />
            <div style="display: flex; align-items: baseline;">
              <input id="part-revision" #partRevision class="form-control" type="text" maxlength="10" [(ngModel)]="commonService.commonMainObj.uploadedFilesData.partRevision"  name="partRevision" (keyup)="commonService.removeRedBorder('part-revision'); changeInSelectInput($event)">
              @if(this.commonService.commonMainObj.partRevHide){
                <div  class="ofp-tooltip" id="partRevHide">
                  <img class=" " src="assets/img/{{commonService.commonMainObj.partRevisionImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(commonService.commonMainObj.partRevisionImg)" (mouseout)="hideImageToolTip(commonService.commonMainObj.partRevisionImg)" style="margin-left: 10px;"/>
                  <span class="tooltiptext right-img-tooltip lableImageLabel-{{commonService.commonMainObj.partRevisionImg}}"></span>
                </div>
              }
            </div>
            <div style="color:red; font-size:10px">Maximum 10 characters</div>
          </div>
        </div>
      </form>
    </div>
  }
  <div>
    @if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0) {
      <div class="bom-table" style="width:100% !important;display: block;">
        <div class="table-row mt-5" id="bom-table-id">
          <table class="table">
            <thead>
              <tr>
                <th>Serial Number</th>
                <th>File Name</th>
                <th>File Type</th>
                <th>File Format </th>
                <th>File Size</th>
                <th>File Last Modified</th>
              </tr>
            </thead>
            @if (commonService.commonMainObj?.uploadedFilesData?.directoryList) {
              <tbody>
                @for (lit of commonService.commonMainObj.listOfAllFiles; track lit; let ind = $index) {
                  <tr>
                    <td>{{ind + 1}}</td>
                    <td>{{lit.name}}</td>
                    <td>{{lit.type}}</td>
                    <td>{{lit.format}}</td>
                    <td>{{lit.fileDetails.fileSize}}</td>
                    <td>{{lit.fileDetails.modifiedDate}}</td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
      </div>
    }
    <div class="text-center mt-4" [ngClass]="this.commonService.commonMainObj.moreFileFormatError ? 'extra-mt' : ''">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Back</b>
    </button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="reUploadFiles()"> <b title="Upload a new design file to start the flow from scratch">Re-upload File</b>
  </button>
  @if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0) {
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5  m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="proceedToBoardsDetails()"> <b>Continue</b>
  </button>
}
<!-- <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5  m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="openModal(alternateMpnModal)"> <b>Open Modal Window</b>
</button> -->
</div>
</div>
</div>
}

<ng-template #alternateMpnModal let-modal class="address-book-modal">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Search Assist</h4>
    <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="modal-crose">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-search-assist></app-search-assist>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" ><b>Proceed</b></button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
  </div>
</ng-template>
</div>

@if (commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0 && !commonService.commonMainObj.uploadedFilesData?.fileWarnings) {
  <div style="display: none;" id="errorFreeFile-wrx4"></div>
}
<app-footer></app-footer>